module.exports = __webpack_public_path__ + "fonts/raleway-v19-latin-ext_latin_cyrillic-ext_cyrillic-900.499b99da.woff2";